import React from 'react';
import cn from 'classnames';
import style from './slotHeader.module.scss';
import MoreAction from '@assets/images/Fireboard/MoreAction';

const SlotHeader = ({ slot, isOccupied, setOverlay, iconRef }) => {
  const handleOverlay = () => {
    setOverlay(prev => ({
      show: !(prev.show && prev.slotId === slot.id),
      slotId: prev.slotId === slot.id ? null : slot.id,
    }));
  };

  return (
    <div
      className={cn(
        'w-100 px-2 d-flex align-items-center justify-content-between position-relative',
        style.slotHeaderContainer
      )}
    >
      <div className="w-70">
        <span className={cn('w-100 text-left')}>{slot?.name}</span>
      </div>
      {isOccupied && (
        <div
          className={cn(
            'w-30 h-100 d-flex align-items-center justify-content-end'
          )}
        >
          <div
            ref={iconRef}
            className={cn(style.moreIcon, style.OverlayOpen)}
            onClick={() => handleOverlay()}
          >
            <MoreAction />
          </div>
        </div>
      )}
    </div>
  );
};

export default SlotHeader;
